module.exports = __webpack_public_path__ + "img/banner-login.128c33ae.jpeg";